import { ListItemText } from "@mui/material";
import React from "react";
import { StyledDatosGenerales } from "../../../../../styled/Empresa";

const DatosGeneralesEnAfip = ({ data }) => {

  return (
    <StyledDatosGenerales.List>
      <StyledDatosGenerales.ListItem key="razonSocial" >
        <ListItemText
          primary="Razón Social"
          secondary={data?.razonSocial ? data.razonSocial : "Sin Información"}
        />
      </StyledDatosGenerales.ListItem>
      <StyledDatosGenerales.ListItem key="cuit" >
        <ListItemText
          primary="CUIT"
          secondary={data?.cuit ? data.cuit : "Sin Información"}
        />
      </StyledDatosGenerales.ListItem>
      <StyledDatosGenerales.ListItem key="inicioActividad" >
        <ListItemText
          primary="Inicio de Actividad"
          secondary={
            data?.inicioActividad ? data.inicioActividad : "Sin Información"
          }
        />
      </StyledDatosGenerales.ListItem>
      <StyledDatosGenerales.ListItem key="codigoActividad" >
        <ListItemText
          primary="Actividad"
          secondary={
            data?.codigoActividad && data?.descripcionActividad
              ? data.codigoActividad + " - " + data.descripcionActividad
              : "Sin Información"
          }
        />
      </StyledDatosGenerales.ListItem>
    </StyledDatosGenerales.List>
  );
};

export default DatosGeneralesEnAfip;
